import { useState } from 'react';
import "./Authors.scss";
import PublicationEthics from './Publication Ethics/PublicationEthics';
import AuthorGuidelines from './Author Guidelines/AuthorGuidelines';
import PaperFormat from './Paper format/Paperformat';
import ProcessingCharges from './Processing Charges/ProcessingCharges';
import CopyRightForm from './Copy Right Form/CopyRightForm';

const Authors = () => {

    const [toggleFormPage, setToggleFormPage] = useState("PublicationEthics");

    return (
        <section className="authorsPageMainContainer">
            {/* Navigation */}
            <nav>
                <button
                    onClick={() => setToggleFormPage("PublicationEthics")}
                    className={toggleFormPage === "PublicationEthics" ? "activeTab" : ""} >
                    Publication Ethics
                </button>
                <button
                    onClick={() => setToggleFormPage("AuthorGuidelines")}
                    className={toggleFormPage === "AuthorGuidelines" ? "activeTab" : ""}>
                    Author Guidelines
                </button>
                <button
                    onClick={() => setToggleFormPage("Paperformat")}
                    className={toggleFormPage === "Paperformat" ? "activeTab" : ""}>
                    Paper format
                </button>
                <button
                    onClick={() => setToggleFormPage("ProcessingCharges")}
                    className={toggleFormPage === "ProcessingCharges" ? "activeTab" : ""}>
                    Processing Charges
                </button>
                <button
                    onClick={() => setToggleFormPage("CopyRightForm")}
                    className={toggleFormPage === "CopyRightForm" ? "activeTab" : ""}>
                    Copy Right Form
                </button>
            </nav>

            {/* Components / Contents */}
            <main>
                {toggleFormPage === "PublicationEthics" ?
                    (<PublicationEthics />)
                    : toggleFormPage === "AuthorGuidelines" ?
                        (<AuthorGuidelines />)
                        : toggleFormPage === "Paperformat" ?
                            (<PaperFormat />)
                            : toggleFormPage === "ProcessingCharges" ?
                                (<ProcessingCharges />) : (<CopyRightForm />)
                }
            </main>
        </section>
    )
}

export default Authors
